import React, { useState, useEffect } from "react";
import styles from "./Portfolio.module.css";
import { Link, useLocation } from "react-router-dom";

export default function Portfolio() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="/#"]');
      if (target && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, [isMenuOpen]);

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [location]);
  // const [hoveredColumn, setHoveredColumn] = useState(null);

  // const hoverClasses = [
  //   styles.hoverColumnHeading,
  //   styles.hoverColumn,
  //   styles.hoverColumnCream,
  //   styles.hoverColumnOrange
  // ];

  // const getColumnHoverClass = (index) =>
  //   hoveredColumn === index ? hoverClasses[index] : "";

  return (
    <section id="portfolio" className="sectionContainer light">
      <div className="sectionTitle">
        <h2>Poznaj nasze projekty</h2>
      </div>
      <div className={styles.portfolioContainer}>
        <div className={styles.portfolioItem}>
          <div className={styles.portfolioDescription}>
            <h2>Strona internetowa dla firmy Spawlove</h2>
            <p>
              Projekt obejmował stworzenie responsywnej strony internetowej
              dopasowanej do potrzeb firmy, wraz z przygotowaniem struktury
              treści i optymalizacją techniczną.{" "}
            </p>
            <p>
              Firma Spawlove specjalizuje się w usługach spawalniczych. Oferuje
              kompleksowe rozwiązania dla klientów indywidualnych oraz
              biznesowych.
            </p>
            <p className={styles.demo}>
              Demo projektu – aplikacja hostowana na moim serwerze wyłącznie w
              celach prezentacyjnych.
            </p>
          </div>
          <div className={styles.goToWebsite}>
            <a
              href="https://projekt-spawlove.artkoz.pl"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.portfolioLink}
              aria-label="Firma Spawlove"
            >
              Odwiedź stronę
              <i className={`${styles.iconToWebsite} fa fa-globe`} />
            </a>
          </div>
        </div>

        <div className={styles.portfolioItem}>
          <div className={styles.portfolioDescription}>
            <h2>Zembo Auto Serwis</h2>
            <p>
              Projekt obejmował stworzenie responsywnej strony internetowej
              dopasowanej do potrzeb firmy, wraz z przygotowaniem struktury
              treści, treści artykułów, grafik oraz optymalizację
              techniczną.{" "}
            </p>
            <p>
              Zembo Auto Serwis to profesjonalny warsztat samochodowy oferujący
              szeroki zakres usług naprawczych i konserwacyjnych dla różnych
              marek i modeli pojazdów.
            </p>
          </div>
          <div className={styles.goToWebsite}>
            <a
              href="https://zemboautoserwis.pl"
              // onClick={closeMenu}
              className={styles.portfolioLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Firma Zembo Auto Serwis"
            >
              Odwiedź stronę
              <i className={`${styles.iconToWebsite} fa fa-globe`} />
            </a>
            {/* <Link
              to="/error"
              onClick={closeMenu}
              className={styles.portfolioLink}
            >
              Odwiedź stronę
              <i className={`${styles.iconToWebsite} fa fa-globe`} />
            </Link> */}
          </div>
        </div>
        <div className={styles.portfolioItem}>
          <div className={styles.portfolioDescription}>
            <h2>Usługi mechaniczne i wulkanizacyjne - projekt autorski</h2>
            <p>
              Autorski projekt strony internetowej przygotowany jako przykład
              realizacji dla branży motoryzacyjnej. Celem projektu było
              zaprezentowanie możliwości projektowych i technologicznych przy
              tworzeniu strony dla warsztatu samochodowego oferującego usługi
              mechaniczne oraz wulkanizacyjne.
            </p>
            <p className={styles.demo}>
              Demo projektu – aplikacja hostowana na moim serwerze wyłącznie w
              celach prezentacyjnych.
            </p>
          </div>
          <div className={styles.goToWebsite}>
            <a
              href="https://projekt-wulkanizacja-mechanik.artkoz.pl/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
              className={styles.portfolioLink}
              aria-label="Firma Spawlove"
            >
              Odwiedź stronę
              <i className={`${styles.iconToWebsite} fa fa-globe`} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
